// extracted by mini-css-extract-plugin
module.exports = {"root":"text_root__6uzED","title":"text_title__ynlj2","kicker":"text_kicker__O5R9G","item":"text_item__QW0kf"};